import { useState } from "react";
import { Select } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useConfigView } from "@/hooks/use-config-view";
import { RefreshCw, FileText } from "lucide-react";

const MODULES = [
  { value: "pjsip", label: "PJSIP (pjsip.conf)" },
  { value: "extensions", label: "Extensions (extensions.conf)" },
  { value: "ari", label: "ARI (ari.conf)" },
  { value: "http", label: "HTTP (http.conf)" },
  { value: "websocket", label: "WebSocket (websocket_client.conf)" },
];

export default function ConfigViewPage() {
  const [module, setModule] = useState("pjsip");
  const { data, isLoading, isError, refetch, isFetching } = useConfigView(module);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Generated Config</h1>
        <p className="text-sm text-muted-foreground mt-1">
          View the raw Asterisk configuration files generated from the database.
        </p>
      </div>

      <div className="flex items-center gap-3">
        <Select
          value={module}
          onChange={(e) => setModule(e.target.value)}
          className="w-72"
        >
          {MODULES.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </Select>
        <Button
          variant="outline"
          size="sm"
          onClick={() => refetch()}
          disabled={isFetching}
          className="gap-1.5"
        >
          <RefreshCw size={14} className={isFetching ? "animate-spin" : ""} />
          Refresh
        </Button>
      </div>

      <Separator />

      <Card>
        <CardHeader className="py-3 px-4">
          <CardTitle className="text-sm flex items-center gap-2">
            <FileText size={14} className="text-muted-foreground" />
            {data?.path ?? MODULES.find((m) => m.value === module)?.label}
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {isLoading && (
            <div className="p-8 text-sm text-muted-foreground text-center">
              Loading config...
            </div>
          )}
          {isError && (
            <div className="p-8 text-sm text-destructive text-center">
              Failed to load config. It may not have been generated yet.
            </div>
          )}
          {data && (
            <pre className="text-xs font-mono bg-muted/30 p-4 overflow-auto max-h-[calc(100vh-280px)] whitespace-pre">
              {data.content || (
                <span className="text-muted-foreground italic">(empty file)</span>
              )}
            </pre>
          )}
        </CardContent>
      </Card>
    </div>
  );
}